import { DataSecurityLevel, } from '@office-start/telemetry-types';
import { logDiagnostic } from './logDiagnostic';
import { logRequest } from './logRequest';
/*
 * This function is used in XHR service:
 *   * custom properties will be logged in Office.Taos.Hub.Diagnostic
 *   * standard properties will be logged in Office.Taos.Hub.Request
 */
export function logRequestWithParams(params, securityThreshold) {
    if (securityThreshold === void 0) { securityThreshold = DataSecurityLevel.Security; }
    logRequest({
        eventName: params.eventName,
        error: params.error,
        latency: params.latency,
        fromCache: params.fromCache,
        httpCode: params.httpCode,
        area: params.area,
        subArea: params.subArea,
    }, securityThreshold);
    // log custom fields to OTEL Diagnostic events
    if (params.instrumentationParams &&
        Object.keys(params.instrumentationParams).length > 0) {
        logDiagnostic({
            eventName: params.eventName,
            params: params.instrumentationParams,
            area: params.area,
            subArea: params.subArea,
        }, securityThreshold);
    }
}
//# sourceMappingURL=logRequestWithParams.js.map